<template>
    <div class="footer">
        <div class="kovatek-background border py-4">
            <div class="row w-90 m-auto my-5 pb-5">
                <div class="col-sm-6 col-md-4 col-lg-2">
                <p class="text-white text-left font-weight-bold pt-3">CONTACT US</p>
                <ul class="text-white text-left reduce-font mr-2 p-0 rmv-deco">
                    <li>
                    
                    <!-- <font-awesome-icon icon="user-secret"></font-awesome-icon> -->
                    <font-awesome-icon icon="phone"></font-awesome-icon> +234-813-748-4495
                    </li>
                    <li><font-awesome-icon icon="envelope"></font-awesome-icon> info@kovatek.com</li>
                    <li class="mt-2">
                    <font-awesome-icon :icon="['fab', 'facebook-f']" class="mx-2 mt-2 icon-size"/>
                    <font-awesome-icon :icon="['fab', 'twitter']" class="mx-2 mt-2 icon-size" />
                    <!-- <font-awesome-icon :icon="['fab', 'linkedin-in']" class="mx-2 mt-2 icon-size" /> -->
                    <font-awesome-icon :icon="['fab', 'instagram']" class="mx-2 mt-2 icon-size" />
                    <!-- <font-awesome-icon :icon="['fab', 'youtube']" class="mx-2 icon-size" /> -->
                    </li>
                </ul>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-2">
                <p class="text-white text-left font-weight-bold pt-3">HIRE DEVELOPERS</p>
                <ul class="text-white text-left reduce-font ml-2 m-0 p-0 rmv-deco">
                    <li> <router-link class="text-white" to="/dev-services/mobile-app"> Mobile App</router-link></li>
                    <li> <router-link class="text-white" to="/dev-services/blockchain"> Blockchain </router-link></li>
                    <li> <router-link class="text-white" to="/dev-services/artificial-intelligence"> A.I </router-link></li>
                    <li> <router-link class="text-white" to="/dev-services/web-app"> Web Application </router-link></li>
                    <li> <router-link class="text-white" to="/dev-services/ui-ux"> UI/UX </router-link></li>
                    <li> <router-link class="text-white" to="/dev-services/cyber-security">CyberSecurity </router-link></li>
                    <li> <router-link class="text-white" to="/dev-services/data-engineering">Data Engineering </router-link></li>
                    <li> <router-link class="text-white" to="/dev-services/devops">DevOps </router-link></li>

                </ul>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-2">
                <p class="text-white text-left font-weight-bold pt-3">ABOUT</p>
                <ul class="text-white text-left reduce-font ml-2 m-0 p-0 rmv-deco">
                    <li>About Us</li>
                    <li>Expert Dev Teams </li>
                    <li>Term of Use</li>
                    <li>Privacy Policy</li>
                </ul>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-2">
                <p class="text-white text-left font-weight-bold pt-3">HELPFUL LINK</p>
                <ul class="text-white text-left reduce-font ml-2 m-0 p-0 rmv-deco">
                    <li>Blog</li>
                    <li>FAQ </li>
                    <li>Hiring Interview Questions</li>
                    <li>Creating a Project</li>
                </ul>
                </div>
                
                <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="py-3 m-auto">
                    <p class="text-white text-left font-weight-bold">SUBSCRIBE</p>
                    <p class="text-white text-left reduce-font">Sign Up for a news letter, daily gigs and remote jobs right in your mailbox</p>
                    <form class="form-inline mr-4 my-2 my-lg-0 w-100">
                        <input class="form-control search-box" type="search" placeholder="Email Address" aria-label="Search">
                        <button class="btn btn-light" type="submit">OK</button>
                    </form>      

                </div>
                </div>
            </div>
            <div class="row w-90">
                <div class="col-sm-12 col-md-6"></div>
                <div class="col-sm-12 col-md-6 px-4 mx-auto mb-4">
                    <h6 class="text-light text-right reduce-font"> <font-awesome-icon icon="copyright" size=""></font-awesome-icon> 2019 Kovatek. All right reserved</h6>
                </div>
            </div>
            </div>
        </div>
</template>

<script>
export default {
    name: 'footer'
}
</script>

<style scoped>
.kovatek-background{
  background-image: url('../assets/kovatek/Footer.svg');
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
}
.rmv-deco{
  list-style-type: none;
}
.icon-size{
  font-size: 16px;
}
.w-90{
  width: 90%;
}
.reduce-font{
    font-size: 12px;
}
.search-box{
    background-color: transparent;
    color: #fff;
    outline: 0;
    height: 40px;
    width: 180px;
    border: solid 1px #fff;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
input::placeholder{
    color: #fff;
    font-size: 12px;
    font-weight: lighter;
}
input:focus::-webkit-input-placeholder{
    color: #000;
}
input:focus::-moz-input-placeholder{
    color: #000;
}
.form-inline button{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 40px;
    width: 60px;
    font-size: 12px;
}
</style>